<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <button v-if="scanKeyModalEnabled" @click="(event) => handleButtonPress(event)">Scan Key</button>
      </div>
    </div>


    <div class="currentView">
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector">
            <SearchBar class="gate-search" v-bind:search="search" :searchIcon="true"
              v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search"
              v-bind:exportDataCallback="() => exportData()"
              :updateDateRangeCallback="(dateRange) => updateDateRange(dateRange)"
              :clearFiltersCallback="() => clearFilters()" :filters="searchCategories"
              :searchCategoryUpdated="(category) => updateFilteredSearch(category, search)" :showSupportButtons="true"
              :updateFiltersCallback="(filters) => handleFilterUpdate(filters)"
              :filterConfiguration="filterConfiguration" />

          </div>
        </div>
        <DataTable v-bind:tableData="tableData" v-bind:openModalCallback="(data) => {
          handleModal(selectedItem, data);
        }
          " :headers="headers" :processInputData="processInputData" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../ContentHeader";
import * as Constants from "../../js/constants";
import EventBus from "../../eventBus";
import DataTable from "./pageComps/DataTable.vue";
import SearchBar from "./pageComps/Search.vue";
import CTSRepository from "../../js/CTSRepository";
// import Insights from "../layout/Insights.vue";
import { formattedDate, formattedTime } from "../../js/Utils.js";

export default {
  name: "GatePage",
  props: ["subPage", "organizationData", "userData"],
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  data() {
    return {
      communityId: "nautica2",
      showKeys: true,
      showIncidents: false,
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      headerName: Constants.GATE,
      subHeader: "Here's a log of all keys sent for your Community.",
      page: this.subPage ? this.subPage : "",
      defaultFilters: {
        residentName: null,
        visitorName: null,
        subdivision: null,
        status: null,
        startTime: null,
        endTime: null
      },
      defaultHeaders: [
        { text: "Visitor Name", value: "visitor_name", align: "start", sortable: true, width: 250 },
        { text: "Resident Name", value: "resident_name", filterable: true, width: 175 },
        { text: "Unit", value: "visiting_address", filterable: false, width: 180 },
        { text: "Rules Accepted?", value: "rules_accepted_display", width: 125 },
        { text: "Pass Printed?", value: "pass_printed_display", width: 125 },
        { text: "Key Start Time", value: "time_active_table_value", filterable: false, width: 180 },
        { text: "Key Expiration Time", value: "expiration", filterable: false, width: 180 },
        { text: "Key Update Time", value: "time_last_updated_table_value", filterable: false, width: 175 },
        { text: "Key Status", value: "current_status", filterable: false, width: 180 },
      ],
      headers: [],
      totalKeys: 0,
      searchCategories: [
        { value: "visitor_name", label: "Visitor Name" },
        { value: "resident_name", label: "Resident Name" },
        { value: "status", label: "Status" },
        { value: "subdivision", label: "Subdivision" },
      ],
      searchFilters: {},
      filterConfiguration: [
        {
          sectionLabel: "Unit Information",
          sectionFields: [
            {
              displayLabel: "Unit Address",
              key: "visitor_first_name",
              configuration: {
                type: 'input',
                placeholder: "Input"
              }
            },
            // {
            //     displayLabel: "Resident Name",
            //     key: "unit_tenant",
            //     configuration: {
            //         type: 'input',
            //         placeholder: "Input"
            //     }
            // },
            {
              displayLabel: "Unit Type",
              key: "unit_type",
              configuration: {
                type: 'select',
                options: [
                  { label: "Non Rental", value: "Non Rental" },
                  { label: "Single Family", value: "Single Family" },
                  { label: "Rental", value: "Rental" }
                ],
                placeholder: "Select"
              }
            }
          ]
        },
        {
          sectionLabel: "Visitor Entry Time",
          sectionFields: [
            {
              displayLabel: "Sort by",
              key: "sort_by",
              configuration: {
                type: 'select',
                options: [
                  { label: "Newest to Oldest", value: "desc" },
                  { label: "Oldest to Newest", value: "asc" }
                ],
                placeholder: "Select"
              }
            }
          ]
        },
      ],
      tableData: [],
      search: "",
      cardInfo: [
        {
          title: "Total Keys Sent",
          value: "--",
          filters: {

          }
        },
        {
          title: "Total Keys Validated",
          value: "3",
          filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "VALIDATED",
            startTime: null,
            endTime: null
          }
        },
        {
          title: "Total Keys Pending",
          value: "3",
        },
        {
          title: "Total Keys Denied",
          value: "1",
        },
        {
          title: "Party Keys Created",
          value: "30",
          filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "CREATED",
            startTime: null,
            endTime: null
          }
        }
      ],
    };
  },
  created() {
    console.log("Gate", this)

    var date = new Date();
    this.defaultEndDate = date.toISOString().split("T")[0];
    var startDate = new Date(date);
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06";
    this.filters = this.defaultFilters
    EventBus.$on("refreshData", () => this.performSearch(this.search))

    this.performSearch("").then((apiData) => {
      console.log("Finished getting and setting API Data", apiData)
      this.search = ""
    });
  },
  mounted() {
    this.updateHeaders()
  },
  watch: {
    search() {
      this.filters = this.defaultFilters
    },
    organizationData: function () {
      this.fetchAllKeys()
    }
  },
  methods: {
    fetchAllKeys() {
      this.updateHeaders()
      if (this.communityId == undefined) {
        return
      }
      return new CTSRepository(this.$props.organizationData).fetchAllKeys()
        .then((data) => {
          const keys = data.data
          const sortedKeys = keys.sort((a, b) => new Date(b.time_active).getTime() - new Date(a.time_active).getTime())
          this.tableData = sortedKeys
          this.cardInfo[0].value = data.data.length

        });
    },
    performSearch(data) {
      this.search = data
      new CTSRepository(this.$props.organizationData).searchKeys(this.searchFilters)
        .then((data) => {
          console.log("Search Data", data);
          const keys = data.data
          const sortedKeys = keys.sort((a, b) => new Date(b.time_active).getTime() - new Date(a.time_active).getTime())
          this.tableData = sortedKeys
          this.cardInfo[0].value = data.data.length
        })
        .catch((err) => {
          console.log("Error searching keys", err)
        });
    },
    processInputData(inputData) {
      return inputData.map(item => {
        //console.log("Mapping over item", item)
        return {
          ...item,
          key_id: item.key_id,
          visitor_name: `${item.visitor_first_name} ${item.visitor_last_name}`,
          resident_name: `${item.user_first_name} ${item.user_last_name}`,
          visiting_address: `${item.unit_data.unit_full_address ?? "Unknown"}`,
          rules_accepted_display: `${item.rules_accepted ? "Yes" : "No"}`,
          pass_printed_display: `${item.pass_printed ? "Yes" : "No"}`,
          time_active_table_value: item.time_active ? `${formattedDate(item.time_active)} ${formattedTime(item.time_active)}` : `${formattedDate(item.time_created)} ${this.formattedTime(item.time_created)}`,
          time_last_updated_table_value: item.time_last_updated ? `${formattedDate(item.time_last_updated)} ${formattedTime(item.time_last_updated)}` : `${formattedDate(item.time_last_updated)} ${this.formattedTime(item.time_last_updated)}`,
          expiration: item.expiration_time ? `${formattedDate(item.expiration_time)} ${formattedTime(item.expiration_time)}` : `${formattedDate(item.time_created)} ${this.formattedTime(item.time_created)}`,
          party_name: item.party_id,
        }
      })
    },
    updateFiltersForSearchBasedOnCard(card) {
      this.filters = card.filters ?? this.defaultFilters
      this.performSearch(this.search).then(() => {
      })
    },
    handleButtonPress() {
      this.$modal.show(Constants.SCAN_KEY_MODAL)
    },
    openGateModal() {
      this.$modal.show(Constants.GATE_MODAL);
    },
    openUsersModal() {
      this.$modal.show("users-modal");
    },
    handleModal(configuration, data) {
      EventBus.$emit(Constants.UPDATE_KEY_MODAL_DATA, data)
    },
    updateFilteredSearch(category, data) {
      console.log(`Updating Filtered Search ${category}, ${data}`)
      if (category == null || category.trim() == "") {
        delete this.searchFilters[this.selectedSearchCategory]
        return;
      }
      //if (data == null || data == undefined || data.trim() == "") {
      delete this.searchFilters[this.selectedSearchCategory]
      delete this.searchFilters[category]
      //    return;
      //}
      console.log(`Updating Filtered Search ${category}, ${data}`)
      this.selectedSearchCategory = category
      this.searchFilters[category] = data
    },
    updateDateRange(dateRange) {
      this.searchFilters['active_time_start'] = dateRange[0]
      this.searchFilters['active_time_end'] = dateRange[1]
    },
    clearFilters() {
      this.searchFilters = {}
      this.selectedSearchCategory = ""
      this.performSearch("")
    },
    handleFilterUpdate(filters) {
      Object.assign(this.searchFilters, filters)
      this.performSearch(this.search)
    },
    updateHeaders() {
      let workingHeaders = [...this.defaultHeaders]
      const passEnabled = this.$config.showParkingPass
      if (!passEnabled) {
        workingHeaders.splice(workingHeaders.findIndex(it => it.text == "Pass Printed?"), 1)
      }
      this.headers = workingHeaders
    }
  },
  computed: {
    scanKeyModalEnabled: function () {
      const enabled = this.$featureEnabledForRole(Constants.SCAN_KEY_MODAL, this.$props.userData['custom:cts_role'])
      console.log("Is Scan Key Featured Enabled for Role", this.$props.userData['custom:cts_role'], enabled)
      return enabled
    }
  }
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.filterIcon {
  margin-right: 16px;
}

input[type="text"]:focus {
  background-color: lightblue;
}

input[type="date"]:focus {
  outline: none;
  border: 0;
  appearance: none;
  border-width: 0px;
  border: none;
}

.pageHeader button {
  background-color: #1890FFCC !important;
}
</style>